import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, Dimensions, View } from 'react-native';
import { Avatar } from '@ui-kitten/components';
import { useSelector} from 'react-redux';

const width = Dimensions.get('window').width;

const EditIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:24,height:24 , marginRight:6, marginLeft:6}]}
    fill = '#8F9BB3'
    name='edit-2'/>
);

const BulbIcon = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 , marginRight:6, marginLeft:6}]}
    fill = '#CEE8F9'
    name='bulb'/>
);

export const AvatarH = () => {
  const user =  useSelector( state => state.login.information);

  return (
      <View style={{ alignItems:'center', marginBottom:10}}>
      <SafeAreaView>
      <Text category='h5' style={{textAlign:'center', color: '#f5f5f5'}}>شبکه همکاران</Text>

          <View style={{flexDirection:'row', justifyContent:'flex-start', alignItems:'center', width, paddingHorizontal: 20}}>

            <View>
            <Avatar
              style={{width:64,height:64, marginVertical:10, borderWidth:3, borderColor:'#CEE8F9'}}
              source={{uri: `https://api.fntpf.ir/assets/uploaded/images/${user.img_uri}`}}
              size='giant'
              />
            </View>
            <View style={{alignItems:'flex-start', marginHorizontal:15}}>
              <Text style={{color: '#CEE8F9'}}>{user.firstname} {user.lastname}</Text>
              <Text appearance='hint'>{user.phone}</Text>
            </View>
            <View>
            </View>
          </View>
          <View style={{flexDirection:'row', marginHorizontal:20, alignItems:'flex-start'}}>
          <BulbIcon />
          <Text category='c2' style={{color: '#CEE8F9', maxWidth: width*0.8}}>
          در صورتی که سوپروایزر هستید، در این قسمت می‌توانید کارهای افراد زیر مجموعه خود را مشاهده نمایید. در غیر این صورت فقط به اطلاعات سوپروایزر خود دسترسی دارید.</Text>
          </View>
          </SafeAreaView>
      </View>
  );
};
